
manatee.app.init_BANG_();